export enum AttackSizeEnum {
  SMALL = 16,
  MEDIUM = 32,
  LARGE = 48,
}
